import React from 'react';
import { Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

class Layout_six_stacked extends Layout_base {
  render() {
    return (
      <Col xs={12}>
        {this.sectionHead()}
        <div className="three-columns-flexed">
          {this.componentDOM(0)}
          {this.componentDOM(1)}
          {this.componentDOM(2)}
          {this.componentDOM(3)}
          {this.componentDOM(4)}
          {this.componentDOM(5)}
        </div>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_six_stacked;
